function AdsNinjaRailAdZone(railElementId, originalAdElementId, data, firstRailElementHeight, logger){

    this.__data                           = data;
    this.__railElementId                  = railElementId;
    this.__originalAdElementIdAdElementId = originalAdElementId;
    this.__adCount                        = 0;
    this.__lastRecordedRailHeight         = 0;
    this.__minimumHeightThreshold         = 0;
    this.__currentlyUsedHeight            = 0;
    this.__railItemElementHeight          = 0;
    this.__adMarginBottom                 = parseInt(this.__data['railItemMargin'] || 0);
    this.__previouslyOmittedMargin        = false;
    this.__firstRailElementHeight         = parseInt(firstRailElementHeight);
    this.__logger                         = (logger) ? logger : new AdsNinjaLogger();

    this.__createNextAdElementId = function(){

        var nextAdElementId = this.__originalAdElementIdAdElementId + `-RAIL-${this.__adCount}`;

        this.__adCount++;

        return nextAdElementId;
    };

    this.__getAdZoneEventsLog = function(){

        return window.adsNinjaHeaderBiddingManager.adZoneEventsLog[this.__adElementId] || null;
    }

    this.__getNextAdHeader = function(adElementId){

        return this.__data['headerTemplate'].replaceAll('DIR_AD_ELEMENT_ID', adElementId);
    };

    this.__getNextAdContent = function(adElementId, marginBottom){

        var nameItem = `adsninja-rail-zone-item-${adElementId}`;

        return `<div class="adsninja-rail-zone-item ${nameItem}" id="${nameItem}" style='margin-bottom: ${marginBottom}px'>` + this.__data['contentTemplateInMainContainer'].replaceAll('DIR_AD_ELEMENT_ID', adElementId) + '</div>';
    };

    this.__getDebugComment = function(currentlyUsedHeight){

        return `<!-- AdsNinja Rail: Currently using a height of "${currentlyUsedHeight}px" for rail items with the total current rail height being "${this.__lastRecordedRailHeight}px". Rail items are "${this.__railItemElementHeight}px" in height with a margin of "${this.__adMarginBottom}px" between them. -->`;
    }

    this.getData = function(){

        return this.__data;
    };

    //
    // Setup rail ad zone.
    this.setup = function(initial = true){

        var railElement = document.getElementById(this.__railElementId);

        if(!railElement){

            this.__logger.warn(`Unable to find rail element with ID: ${this.__railElementId}.`);

            return false;
        }

        // Get height of rail without padding.
        var railElementComputedStyle      = getComputedStyle(railElement);
        var railElementHeight             = railElement.clientHeight;           // Height with padding
        railElementHeight                 -= parseFloat(railElementComputedStyle.paddingTop) + parseFloat(railElementComputedStyle.paddingBottom);

        if(!initial && (railElementHeight - this.__currentlyUsedHeight) < this.__minimumHeightThreshold){

            this.__logger.debug(`Rail element with ID "${this.__railElementId}" is not tall enough to add more items to it.`);

            return false;
        }

        this.__lastRecordedRailHeight = railElementHeight;

        if(!this.__railItemElementHeight){

            var firstRailItemElementId = `adsninja-rail-zone-item-${this.__originalAdElementIdAdElementId}`
            var firstRailItemElement   = document.getElementById(firstRailItemElementId);

            if(!firstRailItemElement){

                this.__logger.warn(`Unable to find first rail item element with ID: ${firstRailItemElementId}.`);

                return false;
            }

            if(firstRailItemElement.classList.contains('hidden')){

                if(this.__firstRailElementHeight < railElementHeight){

                    firstRailItemElement.classList.remove('hidden');
                } else {
                    this.__logger.debug(`Rail element with ID "${this.__railElementId}" is not tall enough to inject any rail ads.`);
                }

            }

            this.__railItemElementHeight = firstRailItemElement.clientHeight;  // Height with padding
        }

        var currentlyUsedHeight = null;

        if(initial){

            currentlyUsedHeight           = this.__railItemElementHeight + this.__adMarginBottom;
            this.__minimumHeightThreshold = this.__railItemElementHeight;

        }
        else{

            currentlyUsedHeight = this.__currentlyUsedHeight;
        }

        if(!this.__railItemElementHeight || !currentlyUsedHeight){

            this.__logger.warn(`Unable to configure rail element with ID: ${this.__railElementId}.`, {
                railAdZone: this,
            });

            return false;
        }

        if(this.__previouslyOmittedMargin){

            railElement.insertAdjacentHTML('beforeend', `<div class="adsninja-rail-zone-item-spacer" style="margin-bottom: ${this.__adMarginBottom}px"></div>`);
        }

        var gamAdSlots    = [];
        var adRefreshData = {};

        // Append ads to rail.
        // Try injecting another ad up until there is no more room for the full height of the ad.
        while(currentlyUsedHeight <= (railElementHeight - (this.__railItemElementHeight + this.__adMarginBottom))){

            var result1 = null;

            try{

                result1             = this.__process(railElement, gamAdSlots, adRefreshData, currentlyUsedHeight);
                gamAdSlots          = result1.gamAdSlots;
                adRefreshData       = result1.adRefreshData;
                currentlyUsedHeight = result1.currentlyUsedHeight;
            }
            catch(error){

                this.__logger.error(`Unable to append ads to rail: error thrown.`, {error: error});
                break;
            }
        }

        this.__previouslyOmittedMargin = false;

        // Try and inject one last ad without a margin.
        if(currentlyUsedHeight <= (railElementHeight - (this.__railItemElementHeight))){

            var result2 = null;

            try{

                result2                        = this.__process(railElement, gamAdSlots, adRefreshData, currentlyUsedHeight, true);
                gamAdSlots                     = result2.gamAdSlots;
                adRefreshData                  = result2.adRefreshData;
                currentlyUsedHeight            = result2.currentlyUsedHeight;
                this.__previouslyOmittedMargin = true;
            }
            catch(error){

                this.__logger.error(`Unable to append ads to rail: error thrown.`, {error: error});
            }
        }

        this.__currentlyUsedHeight = currentlyUsedHeight;
        var debugComment           = this.__getDebugComment(currentlyUsedHeight);

        railElement.insertAdjacentHTML('beforeend', debugComment);

        if(!gamAdSlots || gamAdSlots.length === 0){

            this.__logger.debug(`No ads for auction. Rail element with ID: ${this.__railElementId}.`);

            return false;
        }

        // Create auction for rail items.
        var auction = window.adsNinjaHeaderBiddingManager.setupAjaxAuction(gamAdSlots, window.adsNinjaHeaderBiddingManager.prebidAdUnitBidderConfigs);

        window.adsNinjaHeaderBiddingManager.requestHeaderBids(auction.getId());
        window.adsNinjaHeaderBiddingManager.startFailSafeTimeout(auction.getId());
        window.adsNinjaHeaderBiddingManager.setupFloatingAdZones(auction.getGamAdSlots());
        window.adsNinjaHeaderBiddingManager.setupDynamicallyInjectionRefreshAdZones(auction.getGamAdSlots(), adRefreshData);

        return true;
    };

    //
    // Recalculate the rail ad zones, to inject more ads if the document height increased.
    this.recalculate = function(){

        return this.setup(false);
    };

    this.__process = function(railElement, gamAdSlots, adRefreshData, currentlyUsedHeight, isLastItem = false){

        var adMarginBottom  = (isLastItem) ? 0 : this.__adMarginBottom;
        var adElementId     = this.__originalAdElementIdAdElementId;
        var nextAdElementId = this.__createNextAdElementId();
        var nextAdHeader    = this.__getNextAdHeader(nextAdElementId);
        var nextAdContent   = this.__getNextAdContent(nextAdElementId, adMarginBottom);

        railElement.insertAdjacentHTML('beforeend', nextAdContent);

        // TODO: Make generic function(s) in manager class.

        // Lookup and add the new injected ads in the adsData list.
        var gamAdSlot = window.adsNinjaHeaderBiddingManager.copyAndAddNewAdDataFromExisting(adElementId, nextAdElementId);

        // Safely evaluates the code in gamAdSlot string.
        window.Function(window.adsNinjaHeaderBiddingManager.__stripScriptTags(nextAdHeader))();

        if(nextAdElementId !== gamAdSlot['adElementId']){

            this.__logger.warn(`Unable to find gamAdSlot for rail ad.`, {
                adElementId: nextAdElementId,
            });

            return {
                gamAdSlots: gamAdSlots,
                adRefreshData: adRefreshData,
                currentlyUsedHeight: currentlyUsedHeight,
            };
        }

        gamAdSlots.push(gamAdSlot);

        currentlyUsedHeight            += this.__railItemElementHeight + adMarginBottom;
        adRefreshData[nextAdElementId] = {
            'adElementId':     nextAdElementId,
            'headerTemplate':  this.__data['headerTemplate'],
            'contentTemplate': this.__data['contentTemplate'],
        };

        return {
            gamAdSlots: gamAdSlots,
            adRefreshData: adRefreshData,
            currentlyUsedHeight: currentlyUsedHeight,
        };
    };
}

window.AdsNinjaRailAdZone = AdsNinjaRailAdZone;